import type { SalesforceProduct } from '~/lib/salesforce/types';
import { ClickAndReserveForm } from '~/features/product-details/components/ReservationDrawer/ClickAndReserveForm/ClickAndReserveForm';
import { ReservationStoreSummary } from './ReservationStoreSummary';
import type { ReservationStore } from './types';

type MakeReservationStepProps = {
    product: SalesforceProduct;
    selectedStore: ReservationStore;
    onBack: () => void;
};

export const MakeReservationStep = ({
    product,
    selectedStore,
    onBack,
}: MakeReservationStepProps) => (
    <>
        <ReservationStoreSummary store={selectedStore} onBack={onBack} />
        <ClickAndReserveForm product={product} />
    </>
);
